!function(){"use strict";const t="[data-slider-mobile]",e="[data-slide]",s="[data-slider-thumb]",o="[data-popup-container]",i="[data-popup-close]",n="is-animating",p="is-open",l="data-slider-thumb";customElements.get("look-component")||customElements.define("look-component",class extends HTMLElement{constructor(){super(),this.slider=this.querySelector(t),this.slides=this.querySelectorAll(e),this.thumbs=this.querySelectorAll(s),this.popupContainer=this.querySelector(o),this.popupClose=this.querySelectorAll(i),this.popupCloseByEvent=this.popupCloseByEvent.bind(this)}connectedCallback(){this.slider&&this.slides.length&&this.thumbs.length&&(this.popupContainer.addEventListener("transitionend",(t=>{t.target==this.popupContainer&&(this.popupContainer.classList.remove(n),t.target.classList.contains(p)?this.popupOpenCallback():this.popupCloseCallback())})),this.popupContainer.addEventListener("transitionstart",(t=>{t.target==this.popupContainer&&this.popupContainer.classList.add(n)})),this.popupClose.forEach((t=>{t.addEventListener("click",(()=>{this.popupContainer.classList.remove(p),document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{bubbles:!0}))}))})),this.thumbs.forEach(((t,e)=>{t.addEventListener("click",(s=>{s.preventDefault();const o=t.hasAttribute(l)&&""!==t.getAttribute(l)?parseInt(t.getAttribute(l)):e,i=this.slides[o];if(window.theme.isMobile()){const t=parseInt(window.getComputedStyle(this.slider).paddingLeft);this.slider.scrollTo({top:0,left:i.offsetLeft-t,behavior:"auto"}),document.dispatchEvent(new CustomEvent("theme:scroll:lock",{bubbles:!0})),this.popupContainer.classList.add(n,p)}else{const{stickyHeaderHeight:t}=window.theme.readHeights(),e=i.getBoundingClientRect().top,s=i.offsetHeight/2,o=window.innerHeight;let n=e+s-o/2+window.scrollY;const p=this.getBoundingClientRect().top+window.scrollY,l=p+this.offsetHeight;n<p?n=p-t:n+o>l&&(n=l-o),window.scrollTo({top:n,left:0,behavior:"smooth"})}}))})))}popupCloseByEvent(){this.popupContainer.classList.remove(p)}popupOpenCallback(){document.addEventListener("theme:quick-add:open",this.popupCloseByEvent,{once:!0}),document.addEventListener("theme:product:added",this.popupCloseByEvent,{once:!0})}popupCloseCallback(){document.removeEventListener("theme:quick-add:open",this.popupCloseByEvent,{once:!0}),document.removeEventListener("theme:product:added",this.popupCloseByEvent,{once:!0})}})}();

document.addEventListener('DOMContentLoaded', function() {
  const lookSections = document.querySelectorAll('[data-section-type="look"]');

  lookSections.forEach(section => {
    const dotButtons = section.querySelectorAll('.look__dot__button');
    const hotspotCards = section.querySelectorAll('.hotspot__card');

    dotButtons.forEach(dotButton => {
      dotButton.addEventListener('click', function() {
        const hotspotId = this.dataset.hotspotId;

        // Close any currently active cards in this section
        hotspotCards.forEach(card => {
          if (card.classList.contains('is-active')) {
            card.classList.remove('is-active');
            card.setAttribute('aria-hidden', 'true');
          }
        });

        // Find the corresponding card and open it
        hotspotCards.forEach(card => {
          if (card.dataset.hotspotContent === hotspotId) {
            card.classList.add('is-active');
            card.setAttribute('aria-hidden', 'false');

            // Position the card relative to the dot (you might need to adjust this)
            const dotRect = this.getBoundingClientRect();
            const cardRect = card.getBoundingClientRect();
            const imageRect = section.querySelector('.look__image-container').getBoundingClientRect();

            let top = dotRect.top - imageRect.top - (cardRect.height / 2) + (dotRect.height / 2);
            let left = dotRect.left - imageRect.left - (cardRect.width / 2) + (dotRect.width / 2);

            // Basic boundary checks (you might need more sophisticated logic)
            if (top < 0) top = 10;
            if (left < 0) left = 10;
            if (top + cardRect.height > imageRect.height) top = imageRect.height - cardRect.height - 10;
            if (left + cardRect.width > imageRect.width) left = imageRect.width - cardRect.width - 10;

            card.style.top = `${top}px`;
            card.style.left = `${left}px`;
          }
        });
      });
    });

    // Close cards when clicking outside the card or a dot within this section
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.hotspot__card') && !event.target.closest('.look__dot__button') && event.target.closest('[data-section-type="look"]')) {
        const currentSection = event.target.closest('[data-section-type="look"]');
        const cardsInSection = currentSection.querySelectorAll('.hotspot__card');
        cardsInSection.forEach(card => {
          if (card.classList.contains('is-active')) {
            card.classList.remove('is-active');
            card.setAttribute('aria-hidden', 'true');
          }
        });
      }
    });

    // Close cards when pressing the Escape key
    document.addEventListener('keyup', function(event) {
      if (event.key === 'Escape') {
        hotspotCards.forEach(card => {
          if (card.classList.contains('is-active')) {
            card.classList.remove('is-active');
            card.setAttribute('aria-hidden', 'true');
          }
        });
      }
    });
  });
});